import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/AppContext";

// ONE related-jobs UI for every job page (native OR partner). Items are normalized
// by the backend: { kind, url, title, location, pay, company }.
export default function RelatedJobs({ related, heading }) {
  const { t } = useApp();
  if (!related || related.length === 0) return null;
  return (
    <div className="mt-8" data-testid="related-jobs">
      <h2 className="font-display text-lg uppercase tracking-tight text-white">
        {heading || t.jobDetail?.relatedTitle || "Related jobs"}
      </h2>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {related.map((r, i) => (
          <Link
            key={r.url || i}
            to={r.url}
            className="card-surface p-4 block hover:border-[#FF7A1A]/50"
            data-testid={`related-job-${i}`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="text-sm font-bold text-white line-clamp-1">{r.title}</div>
              {r.kind === "partner" && (
                <span className="chip-orange !text-[9px] !py-0.5 shrink-0" data-testid={`related-job-partner-${i}`}>
                  {t.jobs?.partnerBadge || "Partner"}
                </span>
              )}
            </div>
            <div className="mt-1 text-xs text-zinc-400 line-clamp-1">
              {r.location}{r.pay ? ` · ${r.pay}` : ""}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
